import i18n from '../i18n'

export const getTranslatedText = (text?: string) => {
  const languageObject = text ? JSON.parse(text) : null
  return i18n.language === 'en' ? languageObject?.en ?? '' : languageObject?.no ?? ''
}
